import React from "react";

import {
  useTable,
  useRowSelect,
  useSortBy,
  usePagination,
  useFilters,
} from "react-table";

import {
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Box,
} from "@chakra-ui/react";

export const TableDocumentacao = ({ data, columns }) => {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } =
    useTable(
      {
        columns,
        data,
      },
      useFilters,
      useSortBy,
      usePagination,
      useRowSelect
    );

  return (
    <Box className="break-page">
      <Flex overflowX="auto">
        <Table {...getTableProps} backgroundColor="white" mt="25px">
          <Thead backgroundColor="#ECEFF1">
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th {...column.getHeaderProps()} key={index}>
                    <Flex
                      flexDir="row"
                      alignContent="center"
                      justifyContent="start">
                      <Text textAlign="center" as="p">
                        {column.render("Header")}
                      </Text>
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => {
                    return (
                      <Td
                        key={index}
                        {...cell.getCellProps()}
                        py="6px"
                        fontWeight={500}
                        fontSize="14px"
                        lineHeight="21.6px"
                        color="#6B6C71"
                        pl={cell.column.Header === "Arquivo" && 10}
                        textAlign="start">
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Flex>
    </Box>
  );
};
